

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

require('xo-address-components/src/add-address/directive');

var _logger = require('xo-beaver/dist/logger');

require('xo-form-components/src/dob-nationalid/directive');

require('xo-form-components/src/phone/phoneInput/directive');

var _index = require('xo-models/src/address/index');

var _auth = require('xo-models/src/auth');

require('xo-models/src/bml/index');

var _index2 = require('xo-models/src/checkout/index');

var _index3 = require('xo-models/src/credit/index');

var _index4 = require('xo-models/src/fi/index');

var _index5 = require('xo-models/src/user/index');

require('xo-title/dist/directive');

require('xo-ui-components/src/message/directive');

require('xo-ui-components/src/tooltip/directive');

var _directive = require('../directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBmlApplyPage', function () {
    return {
        template: _template2['default'],
        controller: ['$scope', '$element', function ($scope, $element) {
            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                payee: _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                billingAddresses: _index4.$BillingAddressesModel.instance(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutSession: _index2.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token),
                creditOptions: _index3.$CreditInstallmentModel.instance(_angular.$rootScope.token)
            }).then(function () {
                var defaultBillingAddress = $scope.billingAddresses && $scope.billingAddresses.addresses;

                defaultBillingAddress = defaultBillingAddress.map(function (address, index, array) {
                    if (address && address['default'] === true) {
                        return address;
                    }
                });
                defaultBillingAddress = defaultBillingAddress.length > 0 && defaultBillingAddress[0];

                if (defaultBillingAddress) {
                    $scope.bml.action('napeLookUp', {
                        data: {
                            payer: $scope.checkoutSession.payer,
                            billing_address: {
                                country: defaultBillingAddress.country,
                                line1: defaultBillingAddress.line1,
                                line2: defaultBillingAddress.line2,
                                city: defaultBillingAddress.city,
                                state: defaultBillingAddress.state,
                                postal_code: defaultBillingAddress.postal_code
                            }
                        },
                        success: function success(result) {
                            if (result && result.account_exists === true) {
                                $scope.bml.nape = 'napePotential';
                                $scope.bml.fullApplyRequired = false;
                            }
                        },
                        contingencies: {
                            DEFAULT: function DEFAULT() {
                                // add a log here
                            }
                        }
                    });
                }

                if ($scope.billingAddresses && $scope.billingAddresses.addresses && $scope.billingAddresses.addresses.length > 0) {
                    $scope.billingAddresses.addresses.forEach(function (address) {
                        if (address['default']) {
                            $scope.address = billingAddressObject(address); // eslint-disable-line no-use-before-define
                            $scope.previousDefaultBillingAddress = address;
                        }
                    });
                }

                var bmlData = {
                    reviewUrl: $scope.$parent.reviewUrl,
                    bml: $scope.$parent.bml,
                    bmlApply: $scope.$parent.bmlApply,
                    bmlComplete: $scope.$parent.bmlComplete,
                    checkoutSession: $scope.checkoutSession,
                    auth: $scope.auth,
                    purchase: $scope.checkoutCart.purchase,
                    patchPhone: $scope.patchPhoneModel,
                    billingAddresses: $scope.billingAddresses,
                    merchant: $scope.checkoutAppData.merchant,
                    merchantId: $scope.payee.merchant.id
                };

                $scope.bmlStateHandler = new _directive.$BMLStateHandler(bmlData);

                if ($scope.checkoutSession.payer) {
                    $scope.bmlApply.personalInformation.phone.telephone = $scope.checkoutSession.payer.phone;
                    $scope.bmlApply.personalInformation.phone.phoneType = 'MOBILE';
                    // Set mobile as default to prevent unknown type.
                } else {
                    $scope.bmlFlags.PhoneAdd = true;
                }
            });

            var $el = $($element);

            function handleDobValidation() {
                var $fields = $('#dobSelect .dropdown select');

                $fields.addClass('backendError');
                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            }

            function triggerNextState() {
                _logger.$logger.info('APPLYFORBML_VIEW_SUBMIT');
                if ($scope.bml.nape === 'napePotential') {
                    $scope.bmlStateHandler.applyBML();
                } else {
                    $scope.checkoutSession.message = null;
                    $scope.bmlStateHandler.termsAndCondition();
                }
            }

            function isUserInputtedAddress(address) {
                return address.id === '0';
            }

            function handleValidation(res) {
                if (res && res.fields && res.fields.length) {
                    res.fields.forEach(function (field) {
                        if (field.field) {
                            var $field = $($el.find('[name="' + field.field + '"]'));
                            $field.addClass('backendError');
                        }
                    });
                }

                $scope.checkoutSession.message = {
                    type: 'error',
                    msgKeys: ['genericError.incontextGenericPageError']
                };

                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            }

            function handlePhoneValidation() {
                var $field = $('.telephone');

                $field.addClass('backendError');
                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            }

            function billingAddressObject(address) {
                return new _index4.$BillingAddressModel({
                    line1: address.line1,
                    line2: address.line2,
                    city: address.city,
                    state: address.state,
                    postal_code: address.postal_code,
                    country: $scope.countryCode,
                    full_address: address.full_address,
                    id: '0'
                });
            }

            $scope.showPhone = function () {
                return $scope.checkoutSession.payer.phone && $scope.checkoutSession.payer.phone_type === 'WORK';
            };
            $scope.patchPhoneModel = new _index5.$PatchPhoneModel();
            $scope.patchPhoneModel.token = $scope.token;
            $scope.init = function () {
                $scope.checkoutSession.message = null;
                $scope.previousDefaultBillingAddress = {};
                $scope.bmlFlags = {};
                $scope.address = {};
                $scope.token = _angular.$rootScope.token;
                $scope.countryCode = _squid.$locale.country;
                $scope.validateAddress = new _index.$ValidateAddressModel();
                $scope.validatePhoneModel = new _index5.$ValidatePhoneModel();
                $scope.validatePhoneModel.token = $scope.token;
                $scope.bmlFlags.billingAddressUpdated = false;
                $scope.bmlFlags.AddressAdd = false;
                $scope.bmlFlags.AddressDisplay = true;
                $scope.bmlFlags.PhoneAdd = false;
                $scope.bmlFlags.ChangeLink = true;
                $scope.billingAddressUpdated = false;

                $('.paypalHeaderWrapper').addClass('paypalCredit');
                $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
                $('.paypalHeader').addClass('span14');
                $('.paypalHeader').removeClass('span24');

                if ($scope.bml && $scope.bml.application_status === 'SOFT_DECLINED') {
                    $scope.checkoutSession.message = {
                        type: 'warning',
                        msgKeys: ['applyForBml.bmlDeclineSoft']
                    };
                }
                _logger.$logger.info('APPLYFORBML_VIEW_RENDER');
            };

            $scope.redirectToReview = function () {
                $scope.bmlStateHandler.payInFullRedirect();
            };

            $scope.onContinue = function () {
                if ($scope.validateLegalAge()) {
                    if ($scope.bmlFlags.billingAddressUpdated) {
                        $scope.validateBillingAddress();
                    } else {
                        triggerNextState();
                    }
                }
            };

            $scope.validateLegalAge = function () {
                var dobMonth = $scope.bmlApply.personalInformation.month,
                    dobDay = $scope.bmlApply.personalInformation.day,
                    dobYear = $scope.bmlApply.personalInformation.year,
                    currentDate = new Date(),
                    currentMonth = currentDate.getMonth() + 1,
                    currentDay = currentDate.getDate(),
                    currentYear = currentDate.getFullYear(),
                    largestDOBYear = currentYear - 18; // Legal Age is 18

                var isLegal = dobYear < largestDOBYear || dobYear === largestDOBYear && dobMonth < currentMonth || // eslint-disable-line no-extra-parens
                dobYear === largestDOBYear && dobMonth === currentMonth && dobDay <= currentDay; // eslint-disable-line no-extra-parens

                if (!isLegal) {
                    handleDobValidation();
                }

                return isLegal;
            };

            $scope.changeAddress = function () {
                $scope.bmlFlags.billingAddressUpdated = true;
                $scope.bml.phoneChanged = true;
                $scope.bmlFlags.AddressAdd = true;
                $scope.bmlFlags.AddressDisplay = false;
                $scope.bmlFlags.PhoneAdd = true;
                $scope.bmlFlags.ChangeLink = false;
            };

            $scope.changePlan = function () {
                _uiRouter.$state.go('checkout.chooseCreditOffer');
            };

            $scope.validateBillingAddress = function () {
                var newBilling = billingAddressObject($scope.address);
                newBilling['default'] = true;
                $scope.previousDefaultBillingAddress['default'] = false;
                $scope.validatePhoneModel.save({
                    data: {
                        telephone: $scope.bmlApply.personalInformation.phone.telephone,
                        phoneType: $scope.bmlApply.personalInformation.phone.phoneType
                    },
                    success: function success(result) {

                        if (result) {
                            newBilling.save({
                                data: $scope.billingAddress,

                                success: function success() {
                                    $scope.updateBillingAddress(newBilling);
                                },

                                validation: function validation(res) {
                                    handleValidation(res);
                                }
                            });
                        } else {
                            handlePhoneValidation(result);
                        }
                    },
                    validation: function validation(result) {
                        handlePhoneValidation(result);
                    }
                });
            };

            $scope.updateBillingAddress = function (newBillingAddress) {
                var addresses = $scope.billingAddresses.addresses;
                if (!isUserInputtedAddress(addresses[0])) {
                    addresses.unshift(newBillingAddress);
                } else {
                    addresses[0] = newBillingAddress;
                }
                triggerNextState();
            };

            $scope.init();
        }]
    };
});

_angular.$rootScope;

_squid.$locale;

_squid.$populate;

_uiRouter.$state;

_logger.$logger;

_index.$ValidateAddressModel;

_auth.$AuthModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutSessionModel;

_index3.$CreditInstallmentModel;

_index4.$BillingAddressesModel;

_index4.$BillingAddressModel;

_index5.$PatchPhoneModel;

_index5.$ValidatePhoneModel;

_directive.$BMLStateHandler;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/directive.js
// module id = ../node_modules/xo-credit-components/src/bml-display/xo-bml-apply/directive.js
// module chunks = 0